import Home from "./Home";
import OneWrapper from "./one";

export const AdminCollectsHome = Home;
export const AdminCollectsOneWrapper = OneWrapper;
